module.exports = __webpack_public_path__ + "img/idea_01.a466b1c2.png";